/**
 * @file カートアラートメッセージ
 */
'use strict';
// utility class


/**
 * @classname CartAlertView
 * @classdesc カートアラートメッセージ
 */
export default class CartAlertView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CartAlertView.constructor');
		if(Cookies.get('order-num-change') === 'true'){
			Cookies.remove('order-num-change');
			const $msgModal = $('#messageModal');
			$msgModal.find('.text-message').html('数量を変更しました。');
			$msgModal.modal('show');
		}else{
			const message = $e.val();
			if(message && message !== '') {
				const $msgModal = $('#messageModal');
				$msgModal.find('.text-message').html(message);
				$msgModal.modal('show');
			}
		}
	};
}
